<template>
  <div class="login">
    <div class="login__container" v-if="!modalChangePassword && !modalForgetPassword.active">
      <img src="@\assets\logo.svg" alt="Logo Forge">
      <h2>{{$t('login.TITLE')}}</h2>
      <!-- <h3>{{ route.query.firstLogin == 'true' ? $t('login.instructions.FIRST_LOGIN') : $t('login.instructions.DEFAULT') }}</h3> -->
      <h3>{{ $t('login.instructions.FIRST_LOGIN') }}</h3>
      <div v-if="invalidUserOrPasswordError" class="login-error"><i class="material-icons">error</i>{{ $t('login.errors.INCORRECT_USERNAME_OR_PASSWORD')}}</div>
      <input type="text" @input="onInputPostInvalidLogin" :placeholder="$t('login.inputs.EMAIL')" v-model="username" :class="{'input-invalid': (v$.username.$invalid && submitted) || invalidUserOrPasswordError}">
      <small class="input-message" v-if="v$.username.required.$invalid && submitted"><i class='material-icons'>error_outline</i> {{v$.username.required.$message}}</small>
      <small class="input-message" v-if="v$.username.email.$invalid"><i class='material-icons'>error_outline</i> {{v$.username.email.$message}}</small>
      
      <div class="password_container">
        <input :type="passwordType" @input="onInputPostInvalidLogin" :placeholder="$t('login.inputs.PASSWORD')" v-model="password" :class="{'input-invalid': (v$.password.$invalid && submitted) || invalidUserOrPasswordError}">
        <i v-if="passwordType == 'password'" class="material-icons-outlined" @click.stop="passwordType = 'text'">visibility</i>
        <i v-else class="material-icons-outlined" @click.stop="passwordType = 'password'">visibility_off</i>
      </div>
      <small class="input-message" v-if="v$.password.required.$invalid && submitted"><i class='material-icons'>error_outline</i> {{v$.password.required.$message}}</small>

      <div class="recovery-password" @click.stop="!v$.username.email.$invalid && username.length > 0 ? modalForgetPassword.active = true : modalRecoveryPasswordEmailEmpty = true;">{{$t('login.actions.FORGOT_PASSWORD')}}</div>
      
      <!-- <router-link class="login__recover" to="/login/recoveryPassword">{{ $t("login.forgot-password") }}</router-link> -->
      <button @click="login()" class="login-btn" :disabled="awaitRequest">{{ awaitRequest  ? $t('login.actions.PROCESSING') : $t('login.actions.CONTINUE') }}<i class="material-icons">east</i></button>    

      <!-- <div class="terms">{{ $t("login.instructions.TERMS_AND_CONDITIONS") }} <a href="terms.pdf" target="_blank">{{ $t('login.actions.TERMS_AND_CONDITIONS')}}</a> de Forge Foundation</div> -->
      <div class="create-account">{{ $t("login.instructions.CREATE_ACCOUNT") }} <a @click="router.push({ path: 'register'})">{{ $t("login.instructions.REGISTER") }}</a></div>
    </div>

    <div v-if="modalChangePassword" class="modalChangePassword">
      <i class="material-icons">error_outline</i>
      <h4>Es necesario que cambies la contraseña</h4>
      <div class="modalChangePassword__info">Para esto, revisa tu correo, ya que vas a necesitar el código de verificación que te vamos a enviar.</div>
      <button class="login-btn" @click.stop="router.push({ path: 'recoveryPassword', query: { email: username } })">{{$t('login.actions.CONTINUE')}}<i class="material-icons">east</i></button>
    </div>

    <div v-if="modalForgetPassword.active" class="modalForgetPassword">
      <i class="material-icons">error_outline</i>
      <h4>{{ $t('login.recoveryPassword.TITLE')}}</h4>
      <p>{{ $t('login.recoveryPassword.INSTRUCTION') }}</p>
      <div class="modalForgetPassword__mail"><i class="material-icons-outlined">mail</i><span>{{username}}</span></div>
      <div v-if="modalForgetPassword.error" class="login-error"><i class="material-icons">error</i>{{modalForgetPassword.error}}</div>
      <!--<input type="text" placeholder="Ingresa tu mail" v-model="username" @input="modalForgetPassword.error= ''" @keydown.enter="forgetPassword()" :class="{'input-invalid': (v$.username.$invalid)}">
      <small class="input-message" v-if="v$.username.required.$invalid"><i class='material-icons'>error_outline</i> {{v$.username.required.$message}}</small>
      <div class="modalForgetPassword__info"><i class="material-icons">info</i>Vas a necesitar el código de verificación que te enviaremos por mail</div>-->
      <small class="input-message" v-if="v$.username.email.$invalid"><i class='material-icons'>error_outline</i> {{v$.username.email.$message}}</small>
      

      <div class="modalForgetPassword__actions">
        <button v-if="sendForgetPassword != 'SEND'" class="cancel" @click.stop="modalForgetPassword.active = false; modalForgetPassword.error= ''">{{$t('login.actions.CANCEL')}}</button>
        <button v-if="sendForgetPassword != 'SEND'" class="confirm" @click.stop="forgetPassword()" :disabled="v$.username.$invalid || sendForgetPassword == 'PROCESS'" >{{$t('login.actions.CONTINUE')}}<i class="material-icons">arrow_forward</i></button>
        <button v-if="sendForgetPassword == 'SEND'" class="cancel" @click.stop="modalForgetPassword.active = false; modalForgetPassword.error= ''">Volver</button>
        <button v-if="sendForgetPassword == 'SEND'" class="confirm green"><i class="material-icons">check</i> Enviado</button>
      </div>
    </div>

    <Modal v-if="modalRecoveryPasswordEmailEmpty" :isOpen="modalRecoveryPasswordEmailEmpty" @close="modalRecoveryPasswordEmailEmpty = false" >
      <div class="modal__errorRecoveryPassword">
        <i class="material-icons-outlined">error_outline</i>
        <h3>{{$t('login.instructions.RECOVERY_PASSWORD')}}</h3>
      </div>
    </Modal>
    
  </div>
</template> 
<script>
import { useStore } from 'vuex';
import { onMounted, ref, onBeforeUnmount, computed } from 'vue';
import persistentData from '@/plugins/persistentData';
import { useRouter, useRoute } from 'vue-router';
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import Modal from '../../components/Modal.vue';
//import { useI18n } from 'vue-i18n';

export default {
  components:{
    Modal
},
  setup() {
    const logoText = ref('Comunidad de Educadores')
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const redirect = computed(() => store.getters.getRedirectPath);
    const username = ref("");
    const password = ref("");
    const sendForgetPassword = ref("");
    const modalRecoveryPasswordEmailEmpty = ref(false)
    //const { t } = useI18n();
    let awaitRequest = ref(false);
    const v$ = useVuelidate();
    const submitted = ref(false);
    let invalidUserOrPasswordError = ref(false);
    const passwordType = ref('password');

    const modalChangePassword = ref(false);
    const modalForgetPassword = ref({
      active: false,
      error: false,
      redirecting: false
    });

    onMounted(async () => {
      await store.dispatch('manageUser_disabled');
    });

    function onKeydown (event) {
      if (event.key === 'Enter') {
        login();
      }
    }

    function onInputPostInvalidLogin () {
      if (invalidUserOrPasswordError.value) {
        invalidUserOrPasswordError.value = false;
      }
    }

    window.addEventListener('keydown', onKeydown);
    onBeforeUnmount(() => {
      window.removeEventListener('keydown', onKeydown);
    })

    async function forgetPassword(){
      sendForgetPassword.value = 'PROCESS';
      try {
        modalForgetPassword.value.redirecting = true;
        await store.dispatch('security_beginPasswordRecovery',{ email: username.value });
        sendForgetPassword.value = 'SEND';
      } catch (error) {
        console.log(error.response.data.Message);
        modalForgetPassword.value.redirecting = false;
        sendForgetPassword.value = '';
        if (error.response.data != null && error.response.data.Message == 'USER_NOT_FOUND'){
          modalForgetPassword.value.error = 'El usuario no se encuentra registrado';
        }
        else{
          store.dispatch('notifications_create', { text: 'Ocurrió un error, intente nuevamente' });
        }
      }
    }
    
    async function login () {
      submitted.value = true;
      awaitRequest.value = true;
      if (!v$.value.username.$invalid && !v$.value.password.$invalid) {
        try {
          const request = await store.dispatch('security_authenticate', {username: username.value, password: password.value});
          if (request.status === 200) {
            persistentData.set('token', request.data.token);
            persistentData.set('tokenExpiration', request.data.tokenExpiration);
            persistentData.set('user', JSON.stringify(request.data.user));
            
            await store.dispatch('manageUser_active');
              if(redirect.value && redirect.value != '/login'){
                router.push(redirect.value)
              } else{ 
                router.push('/');
              }
              submitted.value = false;
              awaitRequest.value = false;
          }
        } catch (error) {
          // if (error.response.data == 'Invalid user or password') {
          invalidUserOrPasswordError.value = true;
          //store.dispatch('notifications_create', { text: 'Usuario o contraseña incorrecto' });
          // }
          // if (error.response.data == 'Has to change password') {
          //   modalChangePassword.value = true;
          //   await store.dispatch('security_beginPasswordRecovery',{ email: username.value })
          // }
          awaitRequest.value = false;
          submitted.value = false;
        }
      } else {
        awaitRequest.value = false;
      }
    }

    return {
      logoText,
      username,
      password,
      login,
      onKeydown,
      awaitRequest,
      v$,
      submitted,
      onInputPostInvalidLogin,
      invalidUserOrPasswordError,
      passwordType,
      modalChangePassword,
      modalForgetPassword,
      router,
      route,
      forgetPassword,
      modalRecoveryPasswordEmailEmpty,
      sendForgetPassword
    }
  },
  validations () {
    return {
      username: { 
        required: helpers.withMessage('Este campo es requerido', required),
        email: helpers.withMessage('El formato del mail es inválido', email)
      },
      password: { 
        required: helpers.withMessage('Este campo es requerido', required)
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

$modal-max-width: 520px;
$modal-border-radius: 8px;

.login {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &__container {
    width: 96%;
    max-width: $modal-max-width;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #fff;
    padding: 46px 84px 64px 84px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
    border-radius: $modal-border-radius;
    @media screen and (max-width: 500px) {
      padding: 24px 18px 74px 18px;
    }
    img {
      width: 72px;
      margin: auto;
    }

    h2 {
      color: $black;
      font-weight: 700;
      text-align: center;
      font-size: 20px;
    }
    h3{
      margin-bottom: 8px;
      color: $black;
      font-weight: 600;
      text-align: center;
      font-size: 15px;
    }

    input {
      height: 42px;
      width: 100%;
      padding: 12px 22px;
      margin-bottom: 8px;
      background: #f6f6f6;
      border: none;
      border-radius: 26px;
      color: $black;
 
      &::placeholder {
        color: #7d7d7d;
      }

      &.input-invalid{
        color: $login-error-color;
        border: 1px solid $login-error-color;
      }
      &.input-invalid::placeholder {
        color: $login-error-color;
      }
    }

    .recovery-password {
      width: fit-content;
      align-self: flex-end;
      margin-top: -8px;
      font-size: 12px;
      color: $green;
      font-weight: 500;
      cursor: pointer;
    }

    .terms{
      width: 100%;
      margin-top: 12px;
      text-align: center;
      font-size: 11px;
      font-weight: 500;
      a{
        color: $green;
      }
    }

    .create-account {
      width: 100%;
      margin-top: 12px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      a{
        color: $green;
      } 
    }
  }
}

.login-btn {
  @include icon-and-text-container;
  justify-content: center;
  padding: 8px 0;
  margin-top: 12px;
  background: $green;
  color: #fff;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  &:disabled {
    opacity: .45;
    cursor: default;
  }
}

.password_container{
  position: relative;
  width: 100%;
  height: fit-content;
  //display: flex;
  //align-items: center; 
  .material-icons, .material-icons-outlined {
    position: absolute;
    right: 0;
    top: 20%;
    padding-right: 12px;
    font-size: 24px;
    cursor: pointer;
    color: $black;
  }
}

input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus{
  transition: background-color 5000s ease-in-out 0s;
  font-size: 16px !important;
}

.modalChangePassword{
  width: 96%;
  max-width: $modal-max-width;
  padding: 44px 40px 54px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
  border-radius: $modal-border-radius;
  color: $black;
  .material-icons {
    color: $green;
    font-size: 32px;
  }
  h4{
    font-size: 19px;
  }
  &__info{
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    @media screen and (max-width: $bpSmall) {
      text-align: left;
    }
  }
  .login-btn{
    padding: 8px 22px;
  }
}

.modal{
  &__errorRecoveryPassword{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .material-icons-outlined{
      color: $red;
      font-size: 38px;
      border-radius: 9999px;
    }
    h3{
      margin: 12px 0;
      text-align: center;
      padding: 0 24px;
      font-weight: 600;
    }
  }
}

.modalForgetPassword{
  width: 96%;
  max-width: $modal-max-width;
  @include flex-column;
  gap: 12px;
  background: #fff;
  padding: 44px 40px 54px 40px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
  color: $darkgray;
  border-radius: $modal-border-radius;
  >.material-icons, .material-icons-outlined{
    font-size: 32px;
    color: $green;
  }
  h4{
    color: $black;
    font-size: 17px;
    font-weight: 600;
  }
  p{
    font-size: 14px;
    font-weight: 500;
    color: $black;
    text-align: center;
  }
  &__mail{
    margin: 12px 0 16px 0;
    @include icon-and-text-container;

    .material-icons {
      color: $green;
    }

    span{
      font-weight: 600;
      color: $black;
    }
  }
  &__actions{
    display: flex;
    gap: 22px;
    button{
      @include icon-and-text-container;
      background: $green;
      padding: 8px 22px 8px 32px;
      border-radius: 24px;
      color: #fff;
      font-weight: 500;
      font-size: 17px;
      letter-spacing: .7px;
      &:disabled{
        opacity: .5;
        cursor: default;
      }

      &.green {
        background-color: #4caf50;
      }
    }
    .cancel{
      background: none;
      color: $green;
      border: 1px solid $green;
    }
  }
  @media screen and (max-width: $bpSmall) {
    padding: 44px 20px 54px 20px;
    &__actions{
      display: flex;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
      button{
        padding: 8px 20px;
      }
    }
  }
}

.input-message {
  padding-left: 12px;
  @include icon-and-text-container;
  gap: 4px;
  margin-top: -24px;
  font-size: 13px;
  color: $login-error-color;
  .material-icons, .material-icons-outlined {
    font-size: 18px;
    color: $green;
  }
}

</style>